import type { CreateTeamDTO } from "@nlc/shared-types";

import { useNavigate } from "@tanstack/react-router";

import { toast } from "@/components/toast/toast-queue";
import { FeaturePageLayout } from "@/features/shared/layout/FeaturePageLayout";

import { TeamForm } from "./components/TeamForm";
import { useCreateTeam } from "./shared/hooks/useCreateTeam";

export function CreateTeamPage() {
  const navigate = useNavigate();
  const { mutate: createTeam } = useCreateTeam();

  const handleSubmit = (data: CreateTeamDTO) => {
    createTeam(data, {
      onError: (error) => {
        console.error("Failed to create team", error);
        toast.add(
          {
            description: error.message || "Failed to create team.",
            title: "Error",
            type: "error",
          },
          { timeout: 5000 },
        );
      },
      onSuccess: () => {
        toast.add(
          {
            description: "The team has been successfully created.",
            title: "Team created",
            type: "success",
          },
          { timeout: 5000 },
        );
        navigate({ to: "/teams" });
      },
    });
  };

  return (
    <div className="p-xl">
      <FeaturePageLayout title="Create Team">
        <TeamForm
          onCancel={() => navigate({ to: "/teams" })}
          onSubmit={handleSubmit}
        />
      </FeaturePageLayout>
    </div>
  );
}
